module.exports = __webpack_public_path__ + "static/2-bb95ef3b2149757051b5db300e98d760.png";